import React, { useEffect } from 'react'
import { triggerBiometricsPrompt } from './triggerBiometricsPrompt'

export function useBiometricsCredentials(
  fn: (accountNumber: number, password: string) => void,
  deps?: React.DependencyList
) {
  useEffect(() => {
    return triggerBiometricsPrompt({ onSuccess: fn })
  }, deps ?? [])
}
